'use client';

import { RadialGradientBG } from '@jouzen/ecom-components';

import { PopBottom } from './_components/PopBottom';
import { PopHero } from './_components/PopHero';
import { PopHighlights } from './_components/PopHighlights';
import { PopLifestyle } from './_components/PopLifestyle';
import { PopMembership } from './_components/PopMembership';
import { popGradients } from './_components/PopMembership/data/popGradients';
import { PopStyleComparison } from './_components/PopStyleComparison';

const ContentGen3 = (): JSX.Element => {
  return (
    <div data-cy="content-pop-ring">
      <RadialGradientBG background="sandstone-300" gradients={popGradients}>
        <PopHero />
        <PopHighlights />
        <PopStyleComparison />
        <PopLifestyle />
      </RadialGradientBG>
      <PopMembership />
      <PopBottom />
    </div>
  );
};

export default ContentGen3;
